<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-fish-hook"
    viewBox="0 0 24 24"
    stroke-width="2"
    :width="props.width"
    :height="props.height"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M16 9v6a5 5 0 0 1 -10 0v-4l3 3" />
    <path d="M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M16 5v-2" />
  </svg>
</template>

<script lang="ts" setup>
export interface IconListProps {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IconListProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
